// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2huAx","right":"Footer_right__3Ythi","buttons":"Footer_buttons___ilUo"};